export type MoodDetails = { emoji: string, label: string, message: string };

export const moodDetailsMap: Record<string, MoodDetails> = {
    happy: { emoji: "😁", label: "Happy", message: "Today feels bright and upbeat. It is a good day to tackle your most visible work." },
    content: { emoji: "😊", label: "Content", message: "You are in a steady rhythm today. Keep the pace sustainable and protect your flow." },
    neutral: { emoji: "😐", label: "Neutral", message: "Energy feels balanced today. Keep priorities simple and focus on clean execution." },
    sad: { emoji: "😔", label: "Sad", message: "Take the pressure down today. Focus on one meaningful win and give yourself breathing room." },
    unhappy: { emoji: "😢", label: "Unhappy", message: "Things feel heavy today. Choose lighter tasks where possible and avoid overloading the schedule." },
    tired: { emoji: "😴", label: "Tired", message: "Energy is running low. Reduce context switching and leave space for recovery." },
    stressed: { emoji: "😬", label: "Stressed", message: "Tension is elevated today. Keep meetings tight and prioritise the essentials only." },
    sick: { emoji: "🤒", label: "Sick", message: "Health comes first today. Keep the calendar light and focus only on what truly cannot wait." },
};

export const normalizeMoodType = (moodType?: string | null): string => String(moodType || "")
    .trim()
    .replace(/\s+/g, "")
    .toLowerCase();

export const getMoodDetails = (moodType?: string | null): MoodDetails | null => moodDetailsMap[normalizeMoodType(moodType)] || null;
